import { inject, Service } from "@angular/core";
import { MatPaginatorIntl } from "@angular/material/paginator";
import { TranslocoService } from "@jsverse/transloco";
import { lastValueFrom } from "rxjs";

import { environment } from "../../environments/environment";
import { Languages } from "../api/local-144/models/languages";

@Service()
export class I18nService {
    private readonly translocoService = inject(TranslocoService);

    public getDefaultLang(): Languages {
        const browserLang = localStorage.getItem("lang") ?? this.translocoService.getDefaultLang();
        if (environment.availableLanguages.includes(browserLang as Languages)) {
            return browserLang as Languages;
        }

        return environment.defaultLanguage;
    }

    public async setDefaultLang(language: string): Promise<void> {
        localStorage.setItem("lang", language);
        await lastValueFrom(this.translocoService.load(language));
    }

    public getPaginatorIntl(): MatPaginatorIntl {
        const paginatorIntl = new MatPaginatorIntl();
        paginatorIntl.itemsPerPageLabel = this.translocoService.translate("paginator.items_per_page");
        paginatorIntl.getRangeLabel = this.getRangeLabel.bind(this);

        return paginatorIntl;
    }

    private getRangeLabel(page: number, pageSize: number, length: number): string {
        length = Math.max(length, 0);
        const startIndex = page * pageSize;

        // If the start index exceeds the lists length, do not try and fix the end index to the end.
        const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
        return `${startIndex + 1} - ${endIndex} ${this.translocoService.translate("paginator.of")} ${length}`;
    }
}
